/** Dates du planning en AAAA-MM-JJ (heure locale). */
const pad = (n: number) => String(n).padStart(2, "0");
export const ymd = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const parseYmd = (s: string) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};
export const addDaysYmd = (s: string, n: number) => {
  const d = parseYmd(s);
  return ymd(new Date(d.getFullYear(), d.getMonth(), d.getDate() + n));
};
export function mondayYmd(d = new Date()): string {
  const s = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  return ymd(new Date(s.getFullYear(), s.getMonth(), s.getDate() - ((s.getDay() + 6) % 7)));
}
const DAYS = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];
const MONTHS = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];
export const dayShort = (s: string) => {
  const d = parseYmd(s);
  return `${DAYS[d.getDay()]} ${d.getDate()}`;
};
export const dayLong = (s: string) => parseYmd(s).toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long" });
export const dateShort = (s: string) => {
  const d = parseYmd(s);
  return `${d.getDate()} ${MONTHS[d.getMonth()]}`;
};
export const weekLabel = (from: string) => `Semaine du ${dateShort(from)} au ${dateShort(addDaysYmd(from, 6))}`;
export const isToday = (s: string) => s === ymd(new Date());
export const hoursFmt = (h: number) => {
  const whole = Math.floor(h);
  const min = Math.round((h - whole) * 60);
  return min ? `${whole} h ${String(min).padStart(2, "0")}` : `${whole} h`;
};
